import { Divider, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Event as EventIcon, LocalShipping as LocalShippingIcon, Schedule as ScheduleIcon } from '@material-ui/icons';
import { deliveryTypeToLabel } from '../../constants/delivery-type.constants';
import { DeliveryDay, DeliveryType } from '../../types/delivery-selection.type';

type Props = {
  deliveryType: DeliveryType;
  deliveryDay: DeliveryDay;
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    overflow: 'auto',
    display: 'flex',
    justifyContent: 'space-evenly',
    gap: '3rem',
    marginBottom: '0.5rem',

    '& > div': {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',

      '& > p': {
        fontWeight: 'bold',
        margin: 0,

        '& > span': {
          display: 'block',
          fontWeight: 'normal',
          textTransform: 'capitalize',
        },
      },
    },
  },
}));

export function DeliverySummaryDisplay({ deliveryType, deliveryDay }: Props) {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <div>
        <LocalShippingIcon />
        <p>
          Type de livraison : <span>{deliveryTypeToLabel(deliveryType)}</span>
        </p>
      </div>
      <Divider style={{ height: 50 }} orientation="vertical" light />
      <div>
        <EventIcon />
        <p>
          Date de livraison : <span>{deliveryDay.formattedDate}</span>
        </p>
      </div>
      <Divider style={{ height: 50 }} orientation="vertical" light />
      <div>
        <ScheduleIcon />
        <p>
          Horaire de livraison : <span>{deliveryDay.schedule}</span>
        </p>
      </div>
    </Paper>
  );
}
